module.exports = __webpack_public_path__ + "img/rhythm3.4898b151.png";